<template>
<club-layout>
  <blue-panel />
  <div id="container">
    <div class="item">
      <label id="amount-info" for="amount">{{ $t('lbl.amount') }} <sup id="asterisk">*</sup></label>
      <input type="text" id="amount" name="amount" @input="onInputAmount" :value="amount">
    </div>

    <div class="item">
      <label id="description-info" for="description">{{ $t('lbl.description') }}</label>
      <input id="description" type="text" name="comment" @input="onInputDescription" :value="description">
    </div>

    <div id="buttons">
      <blue-button :title="$t('btn.save')" :onClick="onSaveClick" style="margin-right: 5px" />
      <blue-button :title="$t('btn.cancel')" :onClick="onCancelClick"/>
    </div>
  </div>
</club-layout>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'InvoiceNewPage',
  data: () => ({
    amount: '',
    description: '',
  }),
  methods: {
    ...mapActions(['createInvoice']),
    onInputAmount(e) {
      this.amount = e.target.value;
    },
    onInputDescription(e) {
      this.description = e.target.value;
    },
    async onSaveClick() {
      const { amount, description } = this;

      await this.createInvoice({ amount, description });

      this.$router.replace('/club/invoice/list');
    },
    onCancelClick() {
      this.$router.push('/club/invoice/list');
    },
  },
}
</script>

<style scoped>
  #container {
    margin-top: 20px;
  }

.item {
  width: 60%;
  margin-bottom: 25px;
  position: relative;
}

#amount-info {
  font-size: 13px;
  line-height: 13px;
  display: block;
  color: #424242;
  margin-bottom: 7px;
  font-weight: bold;
  font-family: 'arial', sans-serif;
}

#asterisk {
  color: #ff7058;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: normal;
  vertical-align: baseline;
  outline: 0;
  line-height: 13px;
  font-weight: bold;
  font-family: 'arial', sans-serif;
  cursor: default;
  text-align: left;
}

#amount {
  font-size: 14px;
  display: block;
  margin: 0px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  padding: 0px;
  color: #3b3b3b;
  line-height: 27px;
  height: 27px;
  text-indent: 5px;
  font-family: 'arial', sans-serif;
  -webkit-appearance: textfield;
  background-color: white;
  -webkit-rtl-ordering: logical;
  cursor: text;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-shadow: none;
  text-align: start;
  font: 400 11px system-ui;
  writing-mode: horizontal-tb !important;
}

#description-info {
  font-size: 13px;
  line-height: 13px;
  display: block;
  color: #424242;
  margin-bottom: 7px;
  font-weight: bold;
  font-family: 'arial', sans-serif;
}

#description {
  font-size: 14px;
  display: block;
  margin: 0px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  padding: 0px;
  color: #3b3b3b;
  line-height: 27px;
  height: 27px;
  text-indent: 5px;
  font-family: 'arial', sans-serif;
  -webkit-appearance: textfield;
  background-color: white;
  -webkit-rtl-ordering: logical;
  cursor: text;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-shadow: none;
  text-align: start;
  font: 400 11px system-ui;
  writing-mode: horizontal-tb !important;
}

#buttons {
  background: #e0edf8;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 15px;
}
</style>
